<template>
  <Drawer class="complianceResponsiblePersonDrawer_box" :title="complianceResponsiblePersonTitle" width="800"
    v-model="complianceResponsiblePersonModal" :mask-closable="false" :closable="true"
    @on-visible-change="complianceResponsiblePersonChange" :before-close="handleBeforeClose">
    <Form ref="complianceResponsiblePersonForm" :model="complianceResponsiblePersonForm"
      :rules="ruleValidate" :label-width="labelWidth" @submit.native.prevent>
      <!--负责区域/地区-->
      <Card :bordered="false" dis-hover>
        <template #title>
          <span class="title_box">{{ $t('key1005578') }}</span>
        </template>
        <h3 class="color-666 mb12">{{ $t('key1005579') }}</h3>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005572')" prop="zoneCode">
              <Select class="width_350" v-model="complianceResponsiblePersonForm.zoneCode" transfer filterable @on-change="zoneCodeChange">
                <Option v-for="item in responsibleAreaList" :value="item.zoneCode" :key="item.zoneCode">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005573')" prop="name">
              <Input clearable class="width_350" v-model.trim="complianceResponsiblePersonForm.name" :placeholder="$t('key1000324')"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="complianceResponsiblePersonForm.zoneCode">
            <Form-item :label="$t('key1005574')" prop="countryCode">
              <Select class="width_350" v-model="complianceResponsiblePersonForm.countryCode" transfer filterable @on-change="countryCodeChange">
                <Option v-for="item in responsibleCountryData" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <template v-if="complianceResponsiblePersonForm.countryCode">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001162')" prop="state">
                <Input class="width_350" :placeholder="$t('key1001163')" clearable v-model.trim="complianceResponsiblePersonForm.state"></Input>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001164')" prop="city">
                <Input class="width_350" :placeholder="$t('key1001165')" clearable v-model.trim="complianceResponsiblePersonForm.city"></Input>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001168')" prop="address">
                <Input class="width_350" type="textarea" :maxlength="500"
                  :autosize="{ minRows: 4, maxRows: 6}" v-model.trim="complianceResponsiblePersonForm.address">
                </Input>
              </Form-item>
            </Col>
          </template>
        </Row>
      </Card>
      <!--合规责任人信息-->
      <Card :bordered="false" dis-hover v-if="complianceResponsiblePersonForm.countryCode">
        <template #title>
          <span class="red-dot title_box">{{ $t('key1005580') }}</span>
        </template>
        <h3 class="color-666 mb12">{{ complianceResponsiblePersonText }}</h3>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005575')" prop="phone">
              <div class="flex align-items width_350">
                <Select v-model="complianceResponsiblePersonForm.zipCode" filterable transfer style="width: 140px; margin-right: 12px;">
                  <Option v-for="(item, index) in responsibleCountryData" :value="item.areaCode" :key="index">{{ item.areaCodeName }}</Option>
                </Select>
                <Input :placeholder="$t('key1000324')" clearable v-model.trim="complianceResponsiblePersonForm.phone" style="flex: 1;"></Input>
              </div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005576')" prop="email" :class="emailStyle">
              <Input class="width_350" clearable v-model.trim="complianceResponsiblePersonForm.email" :placeholder="$t('key1000324')"></Input>
              <div class="ivu-form-item-error-tip" v-if="!complianceResponsiblePersonForm.email && emailTalg">{{ $t('key1005567') }}</div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005577')" prop="officialWebsite">
              <Input class="width_350" clearable v-model.trim="complianceResponsiblePersonForm.officialWebsite" :placeholder="$t('key1000324')"></Input>
            </Form-item>
          </Col>
        </Row>
      </Card>
    </Form>
    <div class="drawer_footer">
      <Button class="mr15" type="primary" @click="complianceResponsiblePersonBtn">{{ $t('key1000111') }}</Button>
      <Button @click="cancelBtn">{{ $t('key1000112') }}</Button>
    </div>
  </Drawer>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {commonLocalStorage, getAllCountrysData} from "@/utils/common";

export default {
  name: 'complianceResponsiblePersonDrawer',
  mixins: [Mixin],
  props: {
    responsibleAreaList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      complianceResponsiblePersonModal: false,
      complianceResponsiblePersonTitle: '',
      complianceResponsiblePersonType: null,
      countrysOriginalData: [],
      complianceResponsiblePersonForm: {
        address: '',
        countryCode: null,
        city: '',
        state: '',
        email: '',
        name: '',
        officialWebsite: '',
        phone: '',
        zipCode: null,
        zoneCode: null
      },
      ruleValidate: {
        name: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005564'), trigger: 'blur'}
        ],
        zoneCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005565'), trigger: 'change'}
        ],
        countryCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005566'), trigger: 'change'}
        ],
        address: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001156'), trigger: 'blur'}
        ],
        email: [
          {required: false, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005567'), trigger: 'blur'}
        ],
      },
      responsibleCountryData: [],
      ymsCompliancePersonId: null,
      emailTalg: false,
    };
  },
  computed: {
    complianceResponsiblePersonText() {
      let {zoneCode} = this.complianceResponsiblePersonForm;
      return zoneCode === 'EU' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005568') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005569');
    },
    emailStyle() {
      let txt = '';
      let {zoneCode, email} = this.complianceResponsiblePersonForm;
      if (zoneCode === 'TR') {
        txt = 'required_style_label';
        if (!email) {
          if (this.emailTalg) {
            txt = 'required_style_label ivu-form-item-error';
          } else {
            txt = 'required_style_label';
          }
        }
      }
      return txt;
    }
  },
  methods: {
    // 初始化数据
    initComplianceResponsiblePersonData(type, details) {
      getAllCountrysData('en').then((countryData) => {
        this.ymsCompliancePersonId = null;
        this.$nextTick(() => {
          this.resetData();
        });
        this.countrysOriginalData = countryData;
        this.complianceResponsiblePersonTitle = type === 'add' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005570') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184');
        this.complianceResponsiblePersonType = type;
        if (type === 'edit') {
          this.ymsCompliancePersonId = details.ymsCompliancePersonId;
          this.getComplianceResponsiblePersonDetails(details.ymsCompliancePersonId);
        }
        this.complianceResponsiblePersonModal = true;
      });
    },
    // 获取合规责任人详情
    getComplianceResponsiblePersonDetails(ymsCompliancePersonId) {
      this.axios.get(api.get_ymsCompliancePerson + ymsCompliancePersonId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            this.zoneCodeChange(data.zoneCode);
            for (let key in this.complianceResponsiblePersonForm) {
              this.complianceResponsiblePersonForm[key] = data[key];
            }
          }
        }
      });
    },
    // 选择区域
    zoneCodeChange(value) {
      this.complianceResponsiblePersonForm.countryCode = null;
      this.responsibleCountryData = [];
      if (value) {
        let countriesList = [];
        this.responsibleAreaList.map((item) => {
          if (item.zoneCode === value) {
            countriesList = item.countries;
          }
        });
        this.responsibleCountryData = this.countrysOriginalData.filter((item) => {
          return countriesList.includes(item.twoCode);
        });
        if (value === 'TR') {
          this.complianceResponsiblePersonForm.countryCode = this.responsibleCountryData[0].twoCode;
          this.complianceResponsiblePersonForm.zipCode = this.responsibleCountryData[0].areaCode;
        }
      }
    },
    // 选择责任人国家
    countryCodeChange(value) {
      if (value) {
        this.complianceResponsiblePersonForm.zipCode = null;
        this.responsibleCountryData.map((item) => {
          if (item.twoCode === value) {
            this.complianceResponsiblePersonForm.zipCode = item.areaCode;
          }
        });
      }
    },
    // 确定按钮
    complianceResponsiblePersonBtn() {
      let {zoneCode, officialWebsite, phone, email} = this.complianceResponsiblePersonForm;
      this.$refs.complianceResponsiblePersonForm.validate((valid) => {
        if (valid) {
          if (zoneCode === 'TR') {
            this.emailTalg = true;
            if (!email) {
              this.emailTalg = true;
              return false;
            } else {
              this.emailTalg = false;
            }
          } else {
            if (!officialWebsite && !phone && !email) {
              this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005571'));
              return false;
            }
          }
          let query = {
            ...this.complianceResponsiblePersonForm
          };
          if (this.complianceResponsiblePersonType === 'edit') {
            query.ymsCompliancePersonId = this.ymsCompliancePersonId;
          }
          let url = this.complianceResponsiblePersonType === 'add' ? api.post_ymsCompliancePerson_create : api.post_ymsCompliancePerson_update;
          let text = this.complianceResponsiblePersonType === 'add' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
          this.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.complianceResponsiblePersonModal = false;
              this.$Message.success(text);
              this.ymsCompliancePersonId = null;
              this.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 取消按钮
    cancelBtn() {
      this.handleBeforeClose().then(() => {
        this.resetData();
        this.complianceResponsiblePersonModal = false;
      });
    },
    // 重置数据
    resetData() {
      this.responsibleCountryData = [];
      this.emailTalg = false;
      this.$refs['complianceResponsiblePersonForm'].resetFields();
      this.complianceResponsiblePersonForm = {
        address: '',
        countryCode: null,
        city: '',
        state: '',
        email: '',
        name: '',
        officialWebsite: '',
        phone: '',
        zipCode: null,
        zoneCode: null
      };
    },
    // 关闭之前的二次弹窗提示确认
    handleBeforeClose(value) {
      let v = this;
      return new Promise((resolve, reject) => {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000701'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000702'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            resolve();
          },
          onCancel: () => {
            reject();
          }
        });
      });
    },
    // 监听弹窗
    complianceResponsiblePersonChange(value) {
      if (!value) {
        this.resetData();
        commonLocalStorage.removeItem('autoCreate');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.complianceResponsiblePersonDrawer_box {
  /deep/ .ivu-drawer-body {
    padding: 0 20px;

    .width_350 {
      width: 350px;
    }

    .ivu-card-head {
      padding: 14px 0;
    }

    .ivu-card-body {
      padding: 14px 0;
    }

    .title_box {
      color: #333;
      font-size: 15px;
      font-weight: bold;
      background-color: #fff;
    }

    .red-dot:before {
      content: '*';
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 14px;
      color: #ed4014;
    }
  }

  .drawer_footer {
    width: 800px;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 1px solid #e8eaec;
    text-align: left;
    padding: 12px 0 12px 15px;
    background-color: #fff;
    z-index: 100;
  }
}
</style>
